var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15219 1.37897C5.5429 0.745863 6.46348 0.745863 6.85419 1.37897L7.10412 1.78397C7.33004 2.15004 7.76474 2.33062 8.18354 2.23236L8.64449 2.12421C9.36538 1.95507 10.0137 2.60079 9.84737 3.32235L9.73393 3.81454C9.63832 4.22943 9.81589 4.65936 10.1764 4.88586L10.602 5.15325C11.226 5.5453 11.226 6.4547 10.602 6.84675L10.1764 7.11414C9.81589 7.34064 9.63832 7.77057 9.73393 8.18546L9.84737 8.67766C10.0137 9.39921 9.36538 10.0449 8.64449 9.87579L8.18354 9.76764C7.76475 9.66938 7.33004 9.84996 7.10412 10.216L6.85419 10.621C6.46348 11.2541 5.5429 11.2541 5.1522 10.621L4.90226 10.216C4.67635 9.84996 4.24164 9.66938 3.82284 9.76764L3.3619 9.87579C2.64101 10.0449 1.99273 9.39921 2.15902 8.67766L2.27245 8.18546C2.36807 7.77057 2.1905 7.34064 1.82998 7.11414L1.40439 6.84675C0.780377 6.4547 0.780378 5.5453 1.40439 5.15325L1.82998 4.88586C2.1905 4.65936 2.36807 4.22943 2.27245 3.81454L2.15902 3.32235C1.99273 2.60079 2.64101 1.95507 3.36189 2.12421L3.82284 2.23236C4.24164 2.33062 4.67635 2.15004 4.90226 1.78397L5.15219 1.37897Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.94bb8ab62d17090c442992ca50659626.svg";
export { ForwardRef as ReactComponent };